(function () {
  async function getCart() {
    const res = await fetch("/cart.js", { credentials: "same-origin" });
    return res.json();
  }

  function setBtnText(btn, text) {
    const label = btn.querySelector(".deep-purple-button-label");
    if (label) label.textContent = text;

    // Also prevent Dawn's "sold-out-message" swap from showing SOLD OUT
    const soldOut = btn.querySelector(".sold-out-message");
    if (soldOut) soldOut.textContent = text;
  }

  function hasNonDeepPurpleItem(cart, deepPurpleVariantId) {
    if (!cart || !Array.isArray(cart.items)) return false;
    return cart.items.some((item) => String(item.variant_id) !== String(deepPurpleVariantId));
  }

  function updateButtonsFromCart(cart) {
    const buttons = document.querySelectorAll('[data-deep-purple-button="true"]');
    buttons.forEach((btn) => {
      const dpVariantId = btn.getAttribute("data-deep-purple-variant-id");
      const lockedText = btn.getAttribute("data-deep-purple-locked-text") || "Add another product first";
      const unlockedText = btn.getAttribute("data-deep-purple-unlocked-text") || "Add to cart";

      const unlocked = hasNonDeepPurpleItem(cart, dpVariantId);

      if (unlocked) {
        // Enable + restore label
        btn.disabled = false;
        btn.removeAttribute("aria-disabled");
        setBtnText(btn, unlockedText);
      } else {
        // Lock + set custom label
        btn.disabled = true;
        btn.setAttribute("aria-disabled", "true");
        setBtnText(btn, lockedText);
      }
    });
  }

  async function refresh() {
    try {
      const cart = await getCart();
      updateButtonsFromCart(cart);
    } catch (e) {
      // fail silently
    }
  }

  // Initial sync
  document.addEventListener("DOMContentLoaded", refresh);

  // If user tries to click Deep Purple while locked, ensure message shows (and stays)
  document.addEventListener(
    "click",
    function (e) {
      const btn = e.target.closest('[data-deep-purple-button="true"]');
      if (!btn) return;

      if (btn.disabled) {
        e.preventDefault();
        const lockedText = btn.getAttribute("data-deep-purple-locked-text") || "Add another product first";
        setBtnText(btn, lockedText);
      }
    },
    true
  );

  // Patch fetch to refresh after any cart change (add/change/update/clear)
  const _fetch = window.fetch;
  window.fetch = async function (...args) {
    const res = await _fetch.apply(this, args);
    try {
      const url = (args[0] && args[0].url) || args[0] || "";
      if (typeof url === "string" && url.includes("/cart/")) {
        // Wait a tick so cart is updated server-side, then refresh
        setTimeout(refresh, 150);
      }
    } catch (e) {}
    return res;
  };

  // Also refresh on common theme events (harmless if they don't exist)
  document.addEventListener("cart:refresh", refresh);
  document.addEventListener("cart:updated", refresh);
})();
